import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import BootstrapTable from 'react-bootstrap-table-next';
import { Modal, Col, Row, Container } from 'react-bootstrap';
import { Solicitud_actividad } from './expand/Solicitud_actividad';
import { faSync, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const API_URL = process.env.REACT_APP_API_URL;

function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
}
function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '10%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}
 

export class Solicitud_General_out extends Component {
    static displayName = Solicitud_General_out.name;

    constructor(props) {
        super(props);
        this.state = {
            actividades:[], loading: false, loading2: false,accion:""
        };
          
    
    }

     
    componentDidMount() {
        this.populateActividadesData();
         


    }
     
    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    render() {

        const columns_acti = [
            {
                dataField: 'id',
                text: '#',

                footer: '',
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },
            {
                dataField: 'tipo',
                text: 'Ámbito',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: '',
                formatter: (cellContent, row, rowIndex) => {
                    var ambito = row.tipo.split('|')[1]
                    if (ambito === "R") {
                        return (<div>Docencia Grado</div>)
                    } else if (ambito === "P") {
                        return (<div>Docencia PostGrado</div>)
                    } else if (ambito === "V") {
                        return (<div>Vinculación</div>)
                    } else if (ambito === "I") {
                        return (<div>Investigación</div>)
                    } else if (ambito === "G") {
                        return (<div>Gestion Académica</div>)
                    } else {
                        return (<div>Docencia Admisión</div>)
                    }
                    
                }
            },
            {
                dataField: 'idplnvalidaciondet',
                text: '#',
                hidden: true,
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'descripcion',
                text: 'Descripción',
                headerStyle: color_head_desc('d'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'observacion',
                text: 'Observación',
                headerStyle: color_head_desc('a'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            },
            {
                dataField: 'periodo',
                text: 'Periodo',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row) => {
                    return (<>{row.periodo}</>);
                },
                footer: ''
            },
            {
                dataField: 'accion',
                text: 'Acción',
                formatter: (cellContent, row) => {
                    var accion = row.accion
                    if (row.accion == 'M') {
                        return (<><span className="badge badge-pill badge-warning">Modificar carga</span></>);
                    } else if (row.accion == 'C') {
                        return (<><span className="badge badge-pill badge-success">Nueva carga</span></>);
                    } else {
                        return (<><span className="badge badge-pill badge-danger">Eliminar carga</span></>);
                    }
                    
                },
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            } ];



        return (
            <div>
                  
                        <Row>
                            <Col md="6">
                                <h4 className='resumen'>RESUMEN GENERAL</h4>
                            </Col>
                            <Col md="6"><hr />
                            </Col>
                        </Row>

                {this.state.actividades && this.state.actividades.length > 0 ?

                    <BootstrapTable
                        keyField='idplnvalidaciondet'
                        data={this.state.actividades}
                        columns={columns_acti}
                        bordered={false}
                    /> : null
                }
                      


            </div>
        );
    }

    async populateActividadesData() {
        
        const response = await fetch(API_URL + 'TPlnValidacionDets/' + this.props.idcargadet );
        const respuesta = await response.json();
        const data = respuesta;
        
        this.setState({ actividades: data, loading: false });


    }
}
